import { useTranslation } from 'react-i18next';
import AddressPanel from 'components/AddressPanel/AddressPanel';
import Loader from 'components/Loader/Loader';
import TaxonomyDetailsPanel from 'components/TaxonomyDetailsPanel/TaxonomyDetailsPanel';
import FinancialPanel from 'pages/UserPages/CreateProfitCentre/components/FinancialPanel/FinancialPanel';
import GeneralPanel from 'pages/UserPages/CreateProfitCentre/components/GeneralPanel/GeneralPanel';

import type IProfitCenterForm from '../../interfaces/IProfitCenterForm';

import styles from '../sass/ProfitCentreModal.module.scss';

export default function ProfitCenterForm({
  control,
  enumData,
  recordId,
  startDate,
  onStartDateChange,
  isLoading,
  modalRef,
  dateOpened,
  onDateOpenedChange,
  orgStructureData,
  logicalName,
  setValue,
  naceCodesData,
  naceDivisions,
  onNaceSelectionChange,
  onChangeCountry,
  onChangeState,
  onFindCountries,
  onFindStates,
  onFindCities,
  isStatesDisabled,
  isCitiesDisabled,
  defaultCountries,
  vcOptionsList,
  handleGetVcOptions,
  listPosition,
  trigger,
}: IProfitCenterForm) {
  const { t } = useTranslation();
  const placeholder = recordId ? t('common.notProvided') : '';

  return (
    <div>
      <div className={styles.OwnOperationModalFormWrapper}>
        <Loader isPageLoading={isLoading} isFullLoader={false} />
        <GeneralPanel
          control={control}
          recordId={recordId?.toString() || ''}
          placeholder={placeholder}
          dateOpened={dateOpened}
          onDateOpenedChange={onDateOpenedChange}
          enumData={enumData}
          orgStructureData={orgStructureData}
          logicalName={logicalName}
          setValue={setValue}
          modalRef={modalRef}
          menuPosition="absolute"
          vcOptionsList={vcOptionsList}
          handleGetVcOptions={handleGetVcOptions}
          listPosition={listPosition}
          requiresParentSelection={Boolean(orgStructureData?.length)}
        />
        <TaxonomyDetailsPanel
          control={control}
          naceCodesData={naceCodesData}
          naceDivisions={naceDivisions}
          onNaceSelectionChange={onNaceSelectionChange}
          modalRef={modalRef}
          menuPosition="absolute"
        />
        <FinancialPanel
          control={control}
          startDate={startDate}
          onStartDateChange={onStartDateChange}
          orgStructureData={orgStructureData}
          trigger={trigger}
          requireNetBookWhenNoFirstLayer
        />
        <AddressPanel
          control={control}
          onChangeCountry={onChangeCountry}
          onChangeState={onChangeState}
          onFindCountries={onFindCountries}
          onFindStates={onFindStates}
          onFindCities={onFindCities}
          isStatesDisabled={isStatesDisabled}
          isCitiesDisabled={isCitiesDisabled}
          menuPosition="absolute"
          defaultCountries={defaultCountries}
          requiredState
        />
      </div>
    </div>
  );
}
